var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconControllerBold = function SvgIconControllerBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M4.07 21.48a2.56 2.56 0 0 1-1.878-.77 2.56 2.56 0 0 1-.772-1.88V5.17q0-1.108.772-1.88a2.56 2.56 0 0 1 1.879-.77h13.646q1.108 0 1.88.77.77.772.77 1.88V7h2.212v2.212h-2.212v1.675h2.212v2.226h-2.212v1.675h2.212V17h-2.212v1.83q0 1.108-.77 1.88a2.56 2.56 0 0 1-1.88.77zm0-2.65h13.647V5.17H4.071zM5.888 17h5v-4h-5zm6-7h4V7h-4zm-6 2h5V7h-5zm6 5h4v-6h-4z"
  })));
};
export default SvgIconControllerBold;